import Grid from "@mui/material/Grid";
import React from "react";
import { ReactElement } from "react";
import styled from "styled-components";

interface EqualColumnFlexContainerProps {
    children: ReactElement | ReactElement[],
    gap?: string,
    direction?: string,
    grow?: number
}

const EqualColumnContainer = styled.div<{ direction?: string, grow?: number, gap?: string }>`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    gap: ${(props) => props.gap ?? props.theme.sizes.l};
    flex-direction: ${(props) => props.direction};
    >*{
        flex-basis:0;
        flex-grow:${(props) => props.grow ?? 1};
    }
`;

export const ContainerWIthTopBottomMargin = styled.div<{ margin?: string }>`
    margin-top: ${(props) => props.margin ? props.margin : props.theme.sizes.l};
    margin-bottom: ${(props) => props.margin ? props.margin : props.theme.sizes.l};
`;

export const EqualColumnFlexContainer = ({ children, ...rest }: EqualColumnFlexContainerProps): JSX.Element => {
    return <EqualColumnContainer {...rest}>{children}</EqualColumnContainer>
}


const Container = styled.div<{ direction?: string, gap?: string }>`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    gap: ${(props) => props.gap ?? props.theme.sizes.l};
    flex-direction: ${(props) => props.direction};
`;

interface FlexContainerProps {
    children: ReactElement | ReactElement[],
    gap?: string,
    direction?: string,
    grow?: number
}

export const FlexContainer = ({ children, ...rest }: FlexContainerProps): JSX.Element => {
    return <Container {...rest}>{children}</Container>
}


const Column = styled.div<{ grow?: string, gap?: string }>`
    flex-grow: ${(props) => props.grow};
`;

interface FlexColumnProps {
    children: ReactElement | ReactElement[],
    grow?: string,
    basis?: string
}

export const FlexColumn = ({ children, ...rest }: FlexColumnProps): JSX.Element => {
    return <Column {...rest}>{children}</Column>
}

export const ProductContainerColumn = styled(Grid)`
    margin-top:${(props) => props.theme.sizes.xs};
    margin-bottom:${(props) => props.theme.sizes.xs};

    >div:first-child{
        margin-top:0;
    }
`;

export const ProductFeature = styled(Grid)<{ $lite?: boolean }>`
    background-color: ${(props) => props.$lite ? "#F6F6F6" : props.theme.colors.grey10};
    min-height:80px;
    margin-top:${(props) => props.theme.sizes.xs};
    margin-bottom:${(props) => props.theme.sizes.xs};
    padding:${(props) => props.theme.sizes.s};
`;

export const ProductTitle = styled(ProductFeature)`
    margin-top:${(props) => props.theme.sizes.xs};
    margin-bottom:${(props) => props.theme.sizes.xs};
    background-color: ${(props) => props.theme.colors.grey20};
`;

export const SelectedColumn = styled(ProductContainerColumn)`
        border-style: solid;
        border-color: ${(props) => props.theme.colors.grey30};
        border-width: ${(props) => props.theme.sizes.xs};
        
     >div:nth-of-type(1){
        background-color: ${(props) => props.theme.colors.grey30};
     }
`;